module.exports = __webpack_public_path__ + "img/3.bb9de8b9.png";